import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsDeposit({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M13.61 5.54H3.2a.43.43 0 01-.44-.42c0-.24.2-.43.44-.43h10.5c.24 0 .44-.19.44-.42 0-.7-.6-1.27-1.32-1.27H2.75C1.78 3 1 3.76 1 4.7v8.45c0 .94.78 1.7 1.75 1.7h10.86c.77 0 1.39-.57 1.39-1.27V6.8c0-.7-.62-1.27-1.39-1.27zm-1.23 5.5a.86.86 0 01-.88-.85c0-.46.4-.84.88-.84s.87.38.87.84c0 .47-.4.85-.88.85z" />
    </svg>
  );
}

SvgSettingsDeposit.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsDeposit.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgSettingsDeposit svgRef={ref} {...props} />);
export default ForwardRef;
